import { useState, useEffect } from "react";
import { getTextHorizontalAlignment, getTextVerticalAlign } from "../utils";
import type { TextHorizontalAlignType, VerticalAlignType } from "../utils";

export const useGetTextStyles = (stylesArray: string[]) => {
  const [textHorizontalAlign, setHorizontalAlign] =
    useState<TextHorizontalAlignType | null>(null);
  const [textVerticalAlign, setVerticalAlign] =
    useState<VerticalAlignType | null>(null);

  useEffect(() => {
    const hAligns = getTextHorizontalAlignment(stylesArray);
    const vAligns = getTextVerticalAlign(stylesArray);

    setHorizontalAlign(hAligns[0] ?? null);
    setVerticalAlign(vAligns[0] ?? null);
  }, [stylesArray.join(" ")]);

  return {
    textHorizontalAlign,
    textVerticalAlign,
  };
};
